import React from 'react';

import { withScreenSize } from '../utilities/withScreenSize.jsx';
import { RadarMapWidgetMobile } from './radarMapWidgetMobile';
import { RadarMapWidgetDesktopTablet } from './radarMapWidgetDesktopTablet';
import { reduxConnect } from '../../../common/index.js';

const widgetLinkURL = '/maps?layerId=radar';

const mapStoreStateToProps = (storeState) => {
    const { appState } =  storeState || {};
    const { enableMapsPageOnWeb2 } = appState?.appState || {};    

    return {
        enableMapsPageOnWeb2
    };
};

const mapDispatchToProps = {};
const MapWidget = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(withScreenSize(({ isMobile,  enableMapsPageOnWeb2 }) => {
    if (isMobile) { // doing this differently for since we need a lazy load the map body component
        return <RadarMapWidgetMobile widgetLinkURL={widgetLinkURL} enableMapsPageOnWeb2={enableMapsPageOnWeb2} />;
    }
    return <RadarMapWidgetDesktopTablet widgetLinkURL={widgetLinkURL} enableMapsPageOnWeb2={enableMapsPageOnWeb2} />;
}));

export { MapWidget as default };